import {initializei18n} from "./index"


export default function initialization(default_app_lang) {
    return initializei18n(default_app_lang)
}
